import React from 'react';
import PageLayout from '../Layouts/PageLayout';

const RefundCancellation = () => {
  return (
    <PageLayout title=" Refund & Cancellation Policy ">
      <div className="container mx-auto px-[35px] md:px-[60px] lg:px-[100px] text-[#444444]">
        <h1 className="text-[#B12929] font-bold text-3xl md:text-4xl mb-2 border-b-2 border-gray-200 pb-4">
          Cancellation &amp; Refund Policy
        </h1>
        <p className="mb-8 text-[16px] text-gray-500 italic">for Virat India Micro Finance</p>

        <div className="space-y-8 text-[17px] leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">1. Service Eligibility</h2>
            <p>
              Virat India Micro Finance provides professional consulting services, including estate
              planning, project consultancy, fintech consultancy, business process restructuring,
              virtual CFO services, stressed asset management, and transaction advisory.
            </p>
            <p className="mt-3">
              Due to the nature of consulting services, refunds are generally not applicable once
              services have been rendered or work has commenced.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-[#2c2c2c]">2. Refund Conditions</h2>
            <p className="mb-3">Clients may request a refund only if:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                The consulting engagement has not yet started and no deliverables or work product
                have been provided.
              </li>
              <li>
                Payment has been made in error or for a service not intended or scheduled.
              </li>
              <li>
                The service could not be delivered due to circumstances attributable to Virat India
                Micro Finance (such as consultant unavailability without replacement or cancellation
                of engagement without alternate arrangement).
              </li>
            </ul>
            <p className="mt-3">
              All refund requests must be submitted in writing via email to{' '}
              <a href="mailto:viratindia2023@gmail.com" className="text-[#B12929] hover:underline">
               viratindia2023@gmail.com
              </a>{' '}
              within <strong>7 days of payment</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">3. Non-Refundable Services</h2>
            <p>
              No refunds will be issued for services where work has begun, including preliminary
              assessment, report generation, legal or regulatory filings, or any custom consulting
              activity.
            </p>
            <p className="mt-3">
              Fees paid for government, statutory, or third-party expenses as part of a project are
              strictly non-refundable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">4. Refund Process &amp; Timelines</h2>
            <p>
              Approved refunds will be credited to the original payment method within{' '}
              <strong>7–14 business days</strong> after review and acceptance.
            </p>
            <p className="mt-3">
              The company reserves the right to deduct any applicable payment processing fees,
              administrative charges, or costs already incurred from the refund amount, where
              permissible by law and payment gateway policies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">5. Dispute Resolution</h2>
            <p>
              Any dispute related to payments or service delivery should be addressed via email to{' '}
              <a href="mailto:viratindia2023@gmail.com" className="text-[#B12929] hover:underline">
             viratindia2023@gmail.com
              </a>
              . The team will acknowledge and attempt to resolve the dispute within{' '}
              <strong>14 business days</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-[#2c2c2c]">6. Changes to Policy</h2>
            <p>
              Virat India Micro Finance may amend this policy to remain compliant with payment gateway
              requirements or regulatory changes. Updated policies will be posted on the website and
              apply to future transactions.
            </p>
          </section>

        </div>
      </div>
    </PageLayout>
  );
};

export default RefundCancellation;

